import { Component, AfterViewInit, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MyConfigOrganization } from '../../../../models/myConfig';
import { BackOffice24StatesService } from '../state/back-office24-states.service';
import { Subject, Subscription, Observable, map, takeUntil, catchError, of, finalize } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HttpClient, HttpEventType, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { BackOfficeService } from '../../../../services/backoffice.service';
import moment from 'moment';

@Component({
  selector: 'app-operators',
  standalone: false,
  templateUrl: './operators.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './operators.component.css'
})
export class OperatorsComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() organization: MyConfigOrganization;
  private orgSubscription: Subscription = new Subscription();
  private destroy$ = new Subject<void>();

  public isLoading = false;

  // LPR Camera Statuses
  lprCameras: any[] = [];
  lprCamerasLoading = false;
  lprCameraColumns: string[] = ['sensorId', 'lastRequest'];

  private exportOrdersHostPath: string = JSON.parse(environment.IDENTITY) + "Shuttlebuss/Shuttlebuss.Service/BackOffice/GetExportOrders";
  private exportAdditionalServicesPath: string = JSON.parse(environment.IDENTITY) + "Shuttlebuss/Shuttlebuss.Service/BackOffice/GetExportAdditionalServices";
  private parkingsHostPath: string = JSON.parse(environment.IDENTITY) + "Shuttlebuss/Shuttlebuss.Service/BackOffice/GetExportParkings";
  private paymentsExcelHostPath: string = JSON.parse(environment.IDENTITY) + "Shuttlebuss/Shuttlebuss.Service/BackOffice/GetExportPaymentsExcel";
  private orderParkingsExcelHostPath: string = JSON.parse(environment.IDENTITY) + "Shuttlebuss/Shuttlebuss.Service/BackOffice/GetExportOrderParkingsExcel";
  private timePath: string = JSON.parse(environment.IDENTITY) + "Shuttlebuss/Shuttlebuss.Service/Test/Time";
  private uploadPath: string = JSON.parse(environment.IDENTITY) + "Shuttlebuss/Shuttlebuss.Service/BackOffice/Upload";

  progress: number;
  message: string;
  @Output() public onUploadFinished = new EventEmitter();

  public timeData: any;
  public local: Date;
  public localUtc: Date;
  public displayDate: string;

  public formatter = Intl.DateTimeFormat("sv-SE", {
    timeZone: "Europe/Stockholm",
    day: "numeric",
    month: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    timeZoneName: "short"
  });
  downloadOrdersForm: FormGroup;

  constructor(
    private backOffice24StatesService: BackOffice24StatesService,
    private authHttp: HttpClient,
    private fb: FormBuilder,
    private backOfficeService: BackOfficeService
  ) {
    this.local = new Date();
    this.localUtc = new Date(
      this.local.getUTCFullYear(),
      this.local.getUTCMonth(),
      this.local.getUTCDate(),
      this.local.getUTCHours(),
      this.local.getUTCMinutes(),
      this.local.getUTCSeconds()
    );
    this.getTime().subscribe(data => {
      this.timeData = data;
      this.displayDate = this.formatter.format(new Date(this.timeData.serverTimeUTC));
    });

    console.log('Intl', Intl.DateTimeFormat().resolvedOptions());
  }

  ngOnInit(): void {
    this.orgSubscription = this.backOffice24StatesService.currentOrganization$.subscribe(
      org => {
        this.organization = org;
      }
    );

    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
    this.downloadOrdersForm = this.fb.group({
      ordersFrom: threeMonthsAgo,
      ordersTo: null
    })
  }

  uploadFile = (files) => {
    if (files.length === 0) {
      return;
    }
    let fileToUpload = <File>files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);

    this.authHttp.post(this.uploadPath, formData, { reportProgress: true, observe: 'events' })
      .subscribe({
        next: (event) => {
          if (event.type === HttpEventType.UploadProgress)
            this.progress = Math.round(100 * event.loaded / event.total);
          else if (event.type === HttpEventType.Response) {
            this.message = 'Upload success.';
            this.onUploadFinished.emit(event.body);
          }
        },
        error: (err: HttpErrorResponse) => console.log(err)
      });
  }

  public DownloadOrders(): void {
    this.isLoading = true;
    console.log(this.downloadOrdersForm.get('ordersFrom').value);
    console.log(this.downloadOrdersForm.get('ordersFrom').value?.toISOString()?.split('T')[0] ?? null);
    console.log(this.downloadOrdersForm.get('ordersTo').value);
    console.log(this.downloadOrdersForm.get('ordersTo').value?.toISOString()?.split('T')[0] ?? null);
    const from = this.downloadOrdersForm.get('ordersFrom').value?.toISOString()?.split('T')[0] ?? null;
    const to = this.downloadOrdersForm.get('ordersTo').value?.toISOString()?.split('T')[0] ?? null;
    this.getOrders(from, to)
      .subscribe(x => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([x], { type: "text/csv" });

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);

        var link = document.createElement('a');
        link.href = data;
        var stamp: string = new Date().getUTCFullYear().toString() + new Date().getUTCMonth() + new Date().getDay() + new Date().getUTCHours() + new Date().getUTCMinutes();
        link.download = 'orders_' + stamp + '.csv';
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
        this.isLoading = false;
      });
  }

  public DownloadParkings(): void {
    this.isLoading = true;
    this.getParkings()
      .subscribe(x => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([x], { type: "text/csv" });

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);

        var link = document.createElement('a');
        link.href = data;
        var stamp: string = new Date().getUTCFullYear().toString() + new Date().getUTCMonth() + new Date().getDay() + new Date().getUTCHours() + new Date().getUTCMinutes();
        link.download = 'parkings_' + stamp + '.csv';
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
        this.isLoading = false;
      });
  }

  public DownloadPayments(): void {
    const from = this.toLocalDateString(this.downloadOrdersForm.get('ordersFrom').value);
    // "till" is empty by default, so fall back to today
    const to = this.toLocalDateString(this.downloadOrdersForm.get('ordersTo').value ?? new Date());
    if (!from || !this.organization?.organizationId) {
      console.log('DownloadPayments skipped: from =', from, 'organizationId =', this.organization?.organizationId);
      return;
    }

    this.downloadExcel(this.getPaymentsExcel(from, to), 'payments_' + from + '_' + to + '.xlsx');
  }

  public DownloadOrderParkings(): void {
    const from = this.toLocalDateString(this.downloadOrdersForm.get('ordersFrom').value);
    // "till" is empty by default, so fall back to today
    const to = this.toLocalDateString(this.downloadOrdersForm.get('ordersTo').value ?? new Date());
    if (!from || !this.organization?.organizationId) {
      console.log('DownloadOrderParkings skipped: from =', from, 'organizationId =', this.organization?.organizationId);
      return;
    }

    this.downloadExcel(this.getOrderParkingsExcel(from, to), 'order_parkings_' + from + '_' + to + '.xlsx');
  }

  public getPaymentsExcel(from: string, to: string): Observable<Blob> {
    const params = { from, to, organizationId: this.organization.organizationId };
    return this.authHttp.get(this.paymentsExcelHostPath, { params, responseType: 'blob' });
  }

  public getOrderParkingsExcel(from: string, to: string): Observable<Blob> {
    const params = { from, to, organizationId: this.organization.organizationId };
    return this.authHttp.get(this.orderParkingsExcelHostPath, { params, responseType: 'blob' });
  }

  private downloadExcel(request: Observable<Blob>, fileName: string): void {
    this.isLoading = true;
    request.subscribe({
      next: (x) => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        const newBlob = new Blob([x], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const data = window.URL.createObjectURL(newBlob);

        const link = document.createElement('a');
        link.href = data;
        link.download = fileName;
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

        setTimeout(() => {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
        this.isLoading = false;
      },
      error: (err: HttpErrorResponse) => { console.log(err); this.isLoading = false; }
    });
  }

  // The datepicker value is a moment object here, not a Date. Local calendar date as yyyy-MM-dd,
  // toISOString() would shift it to the previous day in UTC+1/+2
  private toLocalDateString(date: moment.Moment | Date | null): string | null {
    if (!date) {
      return null;
    }
    return moment(date).format('YYYY-MM-DD');
  }

  public getOrders(from: string, to: string): Observable<Blob> {
    return this.authHttp.get(this.exportOrdersHostPath + `?from=${from}&to=${to}`, { responseType: 'blob' });
  }

  public DownloadAdditionalServices(): void {
    this.isLoading = true;
    const from = this.downloadOrdersForm.get('ordersFrom').value?.toISOString()?.split('T')[0] ?? null;
    const to = this.downloadOrdersForm.get('ordersTo').value?.toISOString()?.split('T')[0] ?? null;
    let params = new HttpParams();
    if (from) params = params.set('from', from);
    if (to) params = params.set('to', to);
    this.authHttp.get(this.exportAdditionalServicesPath, { params, responseType: 'blob' }).subscribe({
      next: x => {
        const newBlob = new Blob([x], { type: 'text/csv' });
        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        link.href = data;
        const stamp = new Date().getUTCFullYear().toString() + new Date().getUTCMonth() + new Date().getDay() + new Date().getUTCHours() + new Date().getUTCMinutes();
        link.download = 'additional_services_' + stamp + '.csv';
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        setTimeout(() => { window.URL.revokeObjectURL(data); link.remove(); }, 100);
        this.isLoading = false;
      },
      error: (err: HttpErrorResponse) => { console.log(err); this.isLoading = false; }
    });
  }

  public getParkings(): Observable<Blob> {
    return this.authHttp.get(this.parkingsHostPath, { responseType: 'blob' });
  }


  public getTime(): Observable<any> {
    return this.authHttp.get(this.timePath).pipe(map(this.extractData));
  }

  // public getDashBoardData(): Observable<any> {
  //   return this.authHttp.get(this.dashboardHostPath).pipe(map(this.extractData));
  // }

  private extractData(res: Response) {
    return res || [];
  }

  ngAfterViewInit(): void {
    this.loadLPRCameraStatuses();
  }

  loadLPRCameraStatuses(): void {
    this.lprCamerasLoading = true;
    this.backOfficeService.getLPRCameraStatuses().pipe(
      takeUntil(this.destroy$),
      catchError(() => of([])),
      finalize(() => this.lprCamerasLoading = false)
    ).subscribe((cameras: any[]) => {
      this.lprCameras = cameras.sort((a, b) => (b.minutesAgo ?? -1) - (a.minutesAgo ?? -1));
    });
  }

  getCameraStatusColor(minutesAgo: number | null): string {
    if (minutesAgo === null || minutesAgo === undefined) return 'gray';
    if (minutesAgo < 540) return 'green';
    if (minutesAgo < 1440) return 'orange';
    return 'red';
  }

  formatMinutesAgo(minutesAgo: number | null): string {
    if (minutesAgo === null || minutesAgo === undefined) return 'Aldrig';
    if (minutesAgo < 60) return `${Math.round(minutesAgo)} min sedan`;
    const hours = Math.floor(minutesAgo / 60);
    const mins = Math.round(minutesAgo % 60);
    if (hours < 24) return `${hours}h ${mins}m sedan`;
    const days = Math.floor(hours / 24);
    const remHours = hours % 24;
    return `${days}d ${remHours}h sedan`;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.orgSubscription.unsubscribe();
  }

}
